import React from "react";
import { colors, spacing } from "./theme";

export default function LoadingSpinner({
  size = 42,
  label = "Loading..."
}) {
  return (
    <div style={containerStyle}>
      <div
        style={{
          ...spinnerStyle,
          width: size,
          height: size
        }}
      />

      {label && (
        <p style={labelStyle}>
          {label}
        </p>
      )}
    </div>
  );
}

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: spacing["2xl"]
};

const spinnerStyle = {
  border: `4px solid ${colors.surfaceMuted}`,
  borderTop: `4px solid ${colors.primary}`,
  borderRadius: "50%",
  animation: "spin 0.9s linear infinite"
};

const labelStyle = {
  marginTop: spacing.md,
  color: colors.textMuted,
  fontSize: 14,
  fontWeight: 600
};